import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4ae7b19a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "campaign-alert" }

import {
  CheckCircleIcon,
  ExclamationIcon,
  InformationCircleIcon,
  XCircleIcon,
} from '@heroicons/vue/solid';

interface AlertProps {
  type: 'success' | 'warn' | 'error' | 'info';
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Alert',
  props: {
    type: null
  },
  emits: ['clearError'],
  setup(__props: any, { emit }) {




const clearError = () => {
  emit('clearError');
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.type === 'success')
      ? (_openBlock(), _createBlock(_unref(CheckCircleIcon), {
          key: 0,
          class: "campaign-alert-icon success"
        }))
      : (__props.type === 'info')
        ? (_openBlock(), _createBlock(_unref(InformationCircleIcon), {
            key: 1,
            class: "campaign-alert-icon info"
          }))
        : (__props.type === 'warn')
          ? (_openBlock(), _createBlock(_unref(ExclamationIcon), {
              key: 2,
              class: "campaign-alert-icon warn"
            }))
          : (__props.type === 'error')
            ? (_openBlock(), _createBlock(_unref(XCircleIcon), {
                key: 3,
                class: "campaign-alert-icon error",
                onClick: clearError
              }))
            : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["campaign-alert-text", {
        success: __props.type == 'success',
        info: __props.type == 'info',
        warn: __props.type == 'warn',
        error: __props.type == 'error'
      }])
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 2)
  ]))
}
}

})